import { SpaceType } from './spacing'

type FlexDirectionCSSProps = 'row' | 'row-reverse' | 'column' | 'column-reverse'

type FlexWrapCSSProps = 'nowrap' | 'wrap' | 'wrap-reverse'

type AlignItemsCSSProps = 'stretch' | 'start' | 'center' | 'end' | 'baseline' | 'initial'

type JustifyContentCSSProps =
  | 'start'
  | 'center'
  | 'end'
  | 'space-between'
  | 'space-around'
  | 'initial'

type GridAutoFlowCSSProps = 'row' | 'column' | 'dense' | 'row dense' | 'column dense'

export const settings = {
  blockAxis: {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
  },
  inlineAxis: {
    'space-around': 'space-around',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    'space-between': 'space-between',
  },
}

export type ThemeBlockAxis = keyof typeof settings.blockAxis
export type ThemeInlineAxis = keyof typeof settings.inlineAxis

export type AlignmentProps = {
  alignItems?: AlignItemsCSSProps | AlignItemsCSSProps[]
  flexDirection?: FlexDirectionCSSProps | FlexDirectionCSSProps[]
  flexWrap?: FlexWrapCSSProps | FlexWrapCSSProps[]
  gridArea?: string | string[]
  gridAutoColumns?: SpaceType
  gridAutoFlow?: GridAutoFlowCSSProps
  gridAutoRows?: SpaceType
  gridColumn?: string | string[]
  gridColumnGap?: SpaceType
  gridGap?: SpaceType
  gridRow?: string | string[]
  gridRowGap?: SpaceType
  gridTemplateColumns?: SpaceType
  gridTemplateRows?: SpaceType
  justifyContent?: JustifyContentCSSProps | JustifyContentCSSProps[]
}
